import sdk from '@psp-aggregator/sdk';

export interface UseDealEventsParams {
  enabled?: boolean;
  limit?: number;
  page?: number;
}

export const useDealEvents = (
  dealId: string,
  { enabled = true, limit, page }: UseDealEventsParams = {},
) =>
  sdk.queries.useGetDealEvents(dealId, page, limit, {
    enabled: enabled && dealId.length > 0,
  });
